import product1 from '../../images/Product-1.jpg';
import product2 from '../../images/Product-2.jpg';
import product3 from '../../images/Product-3.jpg';
import sweet1 from '../../images/Sweet-1.jpg';
import sweet2 from '../../images/Sweet-2.jpg';
import sweet3 from '../../images/Sweet-3.jpg';

export const productData = [
  {
    img: product1,
    alt: 'Cake',
    name: 'Royal Wedding Cake',
    desc:
      'Two layers of moist vanilla cake are topped with a creamy vanilla frosting',
    price: '249.99 kr',
    button: 'Add to Cart'
  },
  {
    img: product2,
    alt: 'Cake',
    name: 'Vanilla Bean Cake',
    desc:
      ' The perfect cake for those who prefer a light , soft and refreshing taste',
    price: '160.99 kr',
    button: 'Add to Cart'
  },
  {
    img: product3,
    alt: 'Cake',
    name: 'Rainbow Cake',
    desc:
      ' Our delicious Rainbow Cake in 6 layers of sweet strawberry flavored cake ',
    price: '69.99 kr',
    button: 'Add to Cart'
  }
];

export const productDataTwo = [
  {
    img: sweet2,
    alt: 'Donuts',
    name: 'Doughlicious',
    desc:
      'Belgian chocolate glazed donuts covered in icing with sprinkles on top',
    price: '19.99 kr',
    button: 'Add to Cart'
  },
  {
    img: sweet3,
    alt: 'Ice Cream',
    name: 'Caramel Wonder',
    desc:
      'Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick',
    price: '49.99 kr',
    button: 'Add to Cart'
  },
  {
    img: sweet1,
    alt: 'Brownie',
    name: 'Brownie Bunch',
    desc:
      'Double fudge brownie squares topped with white chocolate pieces and macadamia nuts',
    price: '33.99 kr',
    button: 'Add to Cart'
  }
];
